export default "__VITE_ASSET__CvnAhtXx__"